module.exports = __webpack_public_path__ + "img/product-placeholder-82.b493251.png";